import { SegmentedControl } from 'new/elements/SegmentControl/SegmentControl';
import React, { useState } from 'react';

type Control = {
  label: string;
  value: string;
};

const controls: Control[] = [
  {
    label: 'Records',
    value: 'records',
  },
  {
    label: 'Volume',
    value: 'volume',
  },
  {
    label: 'Errors',
    value: 'errors',
  },
];

type Props = {
  initialValue?: string;
  onControlChange(value: string): void;
};

export function SwitchDataVolumeChart(props: Props) {
  const { initialValue = 'records', onControlChange } = props;
  const [currentValue, setCurrentValue] = useState(initialValue);

  const handleOnControlChange = (value: any) => {
    setCurrentValue(value);
    onControlChange(value);
  };

  return (
    <SegmentedControl
      controls={controls}
      defaultValue={initialValue}
      value={currentValue}
      onControlChange={(_, value) => handleOnControlChange(value)}
    />
  );
}
